import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { ProductRegistrationTable } from '@app/components/apps/ProductRegistration/ProdRegForms/ImportFreeSales/ProductRegistrationTable';

const AllRegistrations: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.replace('/', '');

  const categoryId = Number(localStorage.getItem('selected_category_id')) || 0;
  const categoryName = localStorage.getItem('selected_category_name') || '';

  const routes = [
    { path: 'pr-categories', breadcrumbName: 'Product Registrations' },
    { path: `/${currentPath}`, breadcrumbName: `${categoryName}` },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    addHeaderButton(
      'Register Product',
      <BaseButton type="primary" size="small" onClick={() => navigate('/register-products')}>
        Create
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [categoryId, setBreadcrumb, addHeaderButton, clearHeaderButtons, navigate]);

  return (
    <>
      <PageTitle>Product Registrations</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ProductRegistrationTable />
        </Col>
      </Row>
    </>
  );
};

export default AllRegistrations;
